import api from './kiteApi';
import fallbackSymbols from '../data/symbols.json';

export const SYMBOL_CATALOG_VERSION_KEY = 'KITE_SYMBOL_CATALOG_VERSION';
export const SYMBOL_CATALOG_UPDATED_EVENT = 'kite:symbol-catalog-updated';

function normalizeSymbolItem(item = {}) {
  return {
    symbol: String(item.symbol || '').trim().toUpperCase(),
    company_name: String(item.company_name || item.companyName || '').trim(),
    exchange: String(item.exchange || 'NSE').trim().toUpperCase() || 'NSE',
  };
}

export function bumpSymbolCatalogVersion() {
  const nextVersion = String(Date.now());
  localStorage.setItem(SYMBOL_CATALOG_VERSION_KEY, nextVersion);
  window.dispatchEvent(new CustomEvent(SYMBOL_CATALOG_UPDATED_EVENT, {
    detail: { version: nextVersion },
  }));
  return nextVersion;
}

export async function fetchSymbols() {
  const version = localStorage.getItem(SYMBOL_CATALOG_VERSION_KEY) || '';
  try {
    const response = await api.get('/symbols', {
      params: version ? { v: version } : undefined,
    });
    const items = Array.isArray(response.data?.items) ? response.data.items : [];
    // An empty server catalog is a valid response when no CSV has been
    // imported yet. Keep the order form usable with the bundled catalog until
    // the user imports a full symbol list.
    const normalizedItems = items.map(normalizeSymbolItem).filter((item) => item.symbol);
    return normalizedItems.length > 0
      ? normalizedItems
      : fallbackSymbols.map(normalizeSymbolItem).filter((item) => item.symbol);
  } catch (error) {
    return fallbackSymbols.map(normalizeSymbolItem).filter((item) => item.symbol);
  }
}

export async function importSymbolsCsv(csvText) {
  const response = await api.post('/symbols/import', csvText, {
    headers: {
      'Content-Type': 'text/plain;charset=UTF-8',
    },
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
  });
  return response.data;
}
